import { useState, useEffect, useLayoutEffect, useRef } from "react";
import "./AdminProgramDashboard.css";
import "../components/program/programSections.css";
import { useParams, useNavigate } from "react-router-dom";
import { useAuth, API } from "../App";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { 
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../components/ui/dialog";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../components/ui/dropdown-menu";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../components/ui/select";
import AdminLayout from "../components/AdminLayout";
import TryoutsManagement from "../components/TryoutsManagement";
import GameCards from "../components/GameCards";
import { FeatureGate, UpgradePrompt } from "../components/FeatureGate";
import { useFeatureGate, Features } from "../contexts/FeatureGateContext";
import { 
  ProgramCheckInTab, 

  ProgramStaffTab,
  ProgramRegistrationsTab,
  ProgramFriendRequestsTab,

  ProgramEmailsTab,
  ProgramInvoicesTab,
  ReEnrollmentDialog,
  TeamBuilder
} from "../components/program";

const RetiredCompetitionModule = () => null;
const TournamentBracketBuilder = RetiredCompetitionModule;
const TournamentBracketView = RetiredCompetitionModule;
const TournamentScheduleManager = RetiredCompetitionModule;
const LeagueScheduleBuilder = RetiredCompetitionModule;
const LeagueStandings = RetiredCompetitionModule;
import {
  Trophy, Users, DollarSign, Calendar, MapPin, Clock,
  Edit, ChevronRight, UserPlus, ClipboardList, FileText,
  Mail, Package, CreditCard, AlertCircle, CheckCircle,
  TrendingUp, Percent, BarChart3, LogIn, LogOut, Plus,
  Trash2, UserCheck, UsersRound, Link2, Copy, ExternalLink,
  ClipboardCheck, CalendarDays, Sparkles, Target, QrCode,
  Heart, UserRound, Link, Check, X, Send, Eye, EyeOff, MoreVertical, RefreshCw, Ban,
  Settings, MessageCircle, Bell, Camera, Loader2, Receipt, Shield, Download, AlertTriangle
} from "lucide-react";
import axios from "axios";
import { toast } from "sonner";
import { Switch } from "../components/ui/switch";

const ProgramFrame = ({ children, embedded, title = "" }) => embedded
  ? children
  : <AdminLayout title={title}>{children}</AdminLayout>;

const AdminProgramDashboard = ({ embedded = false, programId: programIdOverride, routeBase = "/admin/programs" }) => {
  const { programId: routeProgramId } = useParams();
  const programId = programIdOverride || routeProgramId;
  const { user, token } = useAuth();
  const navigate = useNavigate();
  const { hasFeature } = useFeatureGate();
  const [loading, setLoading] = useState(true);
  const [program, setProgram] = useState(null);
  const [registrations, setRegistrations] = useState([]);
  const [teams, setTeams] = useState([]);
  const [organizations, setOrganizations] = useState([]);
  const [activeTab, setActiveTab] = useState(
    () => {
      const tab = new URLSearchParams(window.location.search).get("tab");
      return tab === "settings" ? "teams" : tab || "overview";
    }
  );
  const [builderFocus, setBuilderFocus] = useState(false);
  const builderRegionRef = useRef(null);
  const expandBuilderRef = useRef(null);
  const exitBuilderRef = useRef(null);
  const isBuilderTab = activeTab === "teams" || activeTab === "groups";
  const wasBuilderFocused = useRef(false);

  useLayoutEffect(() => {
    if (!builderFocus) {
      if (wasBuilderFocused.current) expandBuilderRef.current?.focus({ preventScroll: true });
      wasBuilderFocused.current = false;
      return;
    }
    wasBuilderFocused.current = true;
    // Keep the builder in place: moving it to a portal would discard local work.
    // Isolate sibling branches, including the embedded organization shell.
    exitBuilderRef.current?.focus();
    const restore = [];
    let branch = builderRegionRef.current;
    while (branch && branch !== document.body) {
      for (const sibling of branch.parentElement?.children || []) {
        if (sibling === branch || !(sibling instanceof HTMLElement)) continue;
        const inert = sibling.getAttribute('inert');
        const ariaHidden = sibling.getAttribute('aria-hidden');
        const visibility = sibling.style.visibility;
        sibling.setAttribute('inert', '');
        sibling.setAttribute('aria-hidden', 'true');
        sibling.style.visibility = 'hidden';
        restore.push(() => {
          if (inert === null) sibling.removeAttribute('inert'); else sibling.setAttribute('inert', inert);
          if (ariaHidden === null) sibling.removeAttribute('aria-hidden'); else sibling.setAttribute('aria-hidden', ariaHidden);
          sibling.style.visibility = visibility;
        });
      }
      branch = branch.parentElement;
    }
    const overflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    // Snapshot layers before Radix can close/unmount them on this same keydown.
    // Bubble at window so inputs, menus and keyboard drag handlers get first refusal.
    const childLayerEvents = new WeakSet();
    const captureKey = event => {
      if (document.querySelector('[role="dialog"], [role="alertdialog"], [role="menu"], [role="listbox"], [data-radix-popper-content-wrapper]')) {
        childLayerEvents.add(event);
      }
    };
    const handleKey = event => {
      if (event.key === 'Escape' && !event.repeat && !event.defaultPrevented && !event.isComposing && !childLayerEvents.has(event)) {
        event.preventDefault();
        setBuilderFocus(false);
      }
    };
    window.addEventListener('keydown', captureKey, true);
    window.addEventListener('keydown', handleKey);
    return () => {
      window.removeEventListener('keydown', captureKey, true);
      window.removeEventListener('keydown', handleKey);
      restore.reverse().forEach(reset => reset());
      document.body.style.overflow = overflow;
    };
  }, [builderFocus]);

  const [tryoutStats, setTryoutStats] = useState(null);
  
  // Team dialog state
  const [teamDialogOpen, setTeamDialogOpen] = useState(false);
  const [editingTeam, setEditingTeam] = useState(null);
  const [teamForm, setTeamForm] = useState({ name: "", color: "#000000", max_players: "" });
  const [availableCoaches, setAvailableCoaches] = useState([]);
  
  // Friend requests state
  const [friendRequestsData, setFriendRequestsData] = useState(null);
  const [friendRequestsLoading, setFriendRequestsLoading] = useState(false);
  const [friendRequestsError, setFriendRequestsError] = useState("");
  
  const linkedTournament = null;
  const tournamentLoading = false;
  
  // Team publishing state
  const [publishingTeam, setPublishingTeam] = useState(null);
  const [publishingAll, setPublishingAll] = useState(false);
  
  // Assign players dialog
  const [assignDialogOpen, setAssignDialogOpen] = useState(false);
  const [selectedTeam, setSelectedTeam] = useState(null);
  const [selectedPlayers, setSelectedPlayers] = useState([]);
  
  // Registration sub-tab state
  const [registrationSubTab, setRegistrationSubTab] = useState('all');
  
  // Re-enrollment dialog state
  const [reEnrollOpen, setReEnrollOpen] = useState(false);
  const [allPrograms, setAllPrograms] = useState([]);

  // Program extras state
  const [extras, setExtras] = useState(null);
  
  // QR Code dialog state
  const [qrDialogOpen, setQrDialogOpen] = useState(false);

  // Squadline state
  const [squadlineStatus, setSquadlineStatus] = useState(null);
  const [squadlineLoading, setSquadlineLoading] = useState(false);
  const [enablingSquadline, setEnablingSquadline] = useState(false);

  // Resolve legacy builder bookmarks once the program type is available.
  useEffect(() => {
    if (program && ["settings", "teams", "groups"].includes(activeTab)) {
      const builderTab = program.program_type === "camp" ? "groups" : "teams";
      if (activeTab !== builderTab) setActiveTab(builderTab);
    }
  }, [program, activeTab]);

  // Helper function to get team/group label based on program type
  const getTeamLabel = (plural = true) => {
    // Camps and Recreational programs with groups_enabled use "Groups"
    if (program?.program_type === "camp" || 
        (program?.program_type === "recreational" && program?.groups_enabled)) {
      return plural ? "Groups" : "Group";
    }
    return plural ? "Teams" : "Team";
  };

  useEffect(() => {
    fetchData();
  }, [programId, token]);

  const fetchData = async () => {
    try {
      const headers = { Authorization: `Bearer ${token}` };
      const [programRes, registrationsRes, teamsRes, orgsRes, coachesRes] = await Promise.all([
        axios.get(`${API}/programs/${programId}`, { headers }),
        axios.get(`${API}/registrations?program_id=${programId}&page_size=100`, { headers }),
        axios.get(`${API}/programs/${programId}/teams`, { headers }).catch(() => ({ data: [] })),
        axios.get(`${API}/organizations`),
        axios.get(`${API}/coaches?status=approved`, { headers }).catch(() => ({ data: [] }))
      ]);
      setProgram(programRes.data || null);
      // Handle both array and paginated response formats, fetch all pages
      const regData = registrationsRes.data;
      let allRegistrations = Array.isArray(regData) ? regData : (regData?.items || []);
      // Fetch remaining pages if paginated
      if (!Array.isArray(regData) && regData?.has_next) {
        let nextPage = 2;
        while (nextPage <= (regData?.total_pages || 1)) {
          try {
            const nextRes = await axios.get(`${API}/registrations?program_id=${programId}&page_size=100&page=${nextPage}`, { headers });
            const nextItems = nextRes.data?.items || [];
            allRegistrations = [...allRegistrations, ...nextItems];
            if (!nextRes.data?.has_next) break;
            nextPage++;
          } catch { break; }
        }
      }
      setRegistrations(allRegistrations);
      setTeams(Array.isArray(teamsRes.data) ? teamsRes.data : []);
      setOrganizations(Array.isArray(orgsRes.data) ? orgsRes.data : []);
      
      // Set available coaches (approved coaches)
      const coachData = coachesRes.data;
      setAvailableCoaches(Array.isArray(coachData) ? coachData : (coachData?.items || coachData?.coaches || []));

      // Fetch program dashboard extras
      try {
        const extrasRes = await axios.get(`${API}/programs/${programId}/dashboard-extras`, { headers });
        setExtras(extrasRes.data);
      } catch (e) {
        console.log("Could not fetch program extras");
      }

      // Fetch all programs for re-enrollment source picker
      try {
        const allProgsRes = await axios.get(`${API}/programs`, { headers });
        const progs = allProgsRes.data;
        setAllPrograms(Array.isArray(progs) ? progs : (progs?.items || []));
      } catch (e) {
        console.log("Could not fetch all programs for re-enrollment");
      }
      
      // Fetch tryout stats if program has tryouts enabled
      if (programRes.data?.tryouts_enabled) {
        try {
          const tryoutStatsRes = await axios.get(
            `${API}/programs/${programId}/tryouts/stats`,
            { headers }
          );
          setTryoutStats(tryoutStatsRes.data);
        } catch (e) {
          console.log("No tryouts for this program");
        }
      }
      
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("Failed to load program data");
      // Reset state on error to prevent crashes
      setProgram(null);
      setRegistrations([]);
      setTeams([]);
    } finally {
      setLoading(false);
    }
  };

  // Squadline functions
  const fetchSquadlineStatus = async () => {
    try {
      setSquadlineLoading(true);
      const headers = { Authorization: `Bearer ${token}` };
      const response = await axios.get(`${API}/squadline/program/${programId}`, { headers });
      setSquadlineStatus(response.data);
    } catch (error) {
      console.log("Could not fetch Squadline status:", error.response?.data?.detail || error.message);
      setSquadlineStatus(null);
    } finally {
      setSquadlineLoading(false);
    }
  };

  const handleSquadlineToggle = async (enabled) => {
    if (enablingSquadline) return;
    
    // If enabling and org not connected, show message
    if (enabled && squadlineStatus && !squadlineStatus.org_connected) {
      toast.error("Your organization must be connected to Squadline first. Go to Settings > Integrations to connect.");
      return;
    }
    
    // Confirm action
    const action = enabled ? "enable" : "disable";
    const message = enabled 
      ? `This will enable Squadline capability for this program. Sync teams separately to send invitations. Continue?`
      : `This will disable Squadline for all teams in this program. Parents will no longer have access via Squadline. Continue?`;
    
    if (!window.confirm(message)) return;
    
    try {
      setEnablingSquadline(true);
      const headers = { Authorization: `Bearer ${token}` };
      const response = await axios.post(
        `${API}/squadline/program/${programId}/${action}`,
        {},
        { headers }
      );
      
      toast.success(response.data.message);
      await fetchSquadlineStatus();
      await fetchData(); // Refresh teams
    } catch (error) {
      toast.error(error.response?.data?.detail || `Failed to ${action} Squadline`);
    } finally {
      setEnablingSquadline(false);
    }
  };

  // Load Squadline status when Settings or Teams tab is active
  useEffect(() => {
    if ((activeTab === "settings" || activeTab === "teams" || activeTab === "groups") && program && !squadlineStatus && !squadlineLoading) {
      fetchSquadlineStatus();
    }
  }, [activeTab, program]);

  // Navigate to settings for Squadline connection
  const handleConnectSquadline = () => {
    navigate("/admin/settings?tab=integrations");
  };

  // Check-in/out functions
  const handleCheckIn = async (registrationId) => {
    try {
      const headers = { Authorization: `Bearer ${token}` };
      await axios.post(`${API}/registrations/${registrationId}/checkin`, {
        registration_id: registrationId,
        check_type: "in"
      }, { headers });
      toast.success("Player checked in!");
      fetchData();
    } catch (error) {
      toast.error("Failed to check in player");
    }
  };

  const handleCheckOut = async (registrationId) => {
    try {
      const headers = { Authorization: `Bearer ${token}` };
      await axios.post(`${API}/registrations/${registrationId}/checkin`, {
        registration_id: registrationId,
        check_type: "out"
      }, { headers });
      toast.success("Player checked out!");
      fetchData();
    } catch (error) {
      toast.error("Failed to check out player");
    }
  };

  // Team functions
  const handleCreateTeam = async () => {
    const isGroupMode = program?.groups_enabled;
    const entityName = isGroupMode ? "Group" : "Team";
    
    if (!teamForm.name) {
      toast.error(`${entityName} name is required`);
      return;
    }
    
    try {
      const headers = { Authorization: `Bearer ${token}` };
      const payload = {
        program_id: programId,
        name: teamForm.name,
        color: teamForm.color,
        max_players: teamForm.max_players ? parseInt(teamForm.max_players) : null
      };
      
      if (editingTeam) {
        await axios.put(`${API}/teams/${editingTeam.team_id}`, payload, { headers });
        toast.success(`${entityName} updated!`);
      } else {
        await axios.post(`${API}/teams`, payload, { headers });
        toast.success(`${entityName} created!`);
      }
      
      setTeamDialogOpen(false);
      setEditingTeam(null);
      setTeamForm({ name: "", color: "#000000", max_players: "" });
      fetchData();
    } catch (error) {
      toast.error(`Failed to save ${entityName.toLowerCase()}`);
    }
  };

  const handleDeleteTeam = async (teamId) => {
    if (!confirm("Are you sure you want to delete this team?")) return;
    
    try {
      const headers = { Authorization: `Bearer ${token}` };
      await axios.delete(`${API}/teams/${teamId}`, { headers });
      toast.success("Team deleted!");
      fetchData();
    } catch (error) {
      toast.error("Failed to delete team");
    }
  };

  const openEditTeam = (team) => {
    setEditingTeam(team);
    setTeamForm({
      name: team.name,
      color: team.color || "#000000",
      max_players: team.max_players?.toString() || ""
    });
    setTeamDialogOpen(true);
  };

  const handleAssignPlayers = async () => {
    if (!selectedTeam || selectedPlayers.length === 0) return;
    
    try {
      const headers = { Authorization: `Bearer ${token}` };
      await axios.post(`${API}/teams/${selectedTeam}/players`, {
        registration_ids: selectedPlayers
      }, { headers });
      toast.success("Players assigned to team!");
      setAssignDialogOpen(false);
      setSelectedTeam(null);
      setSelectedPlayers([]);
      fetchData();
    } catch (error) {
      toast.error("Failed to assign players");
    }
  };

  const handleRemoveFromTeam = async (teamId, registrationId) => {
    try {
      const headers = { Authorization: `Bearer ${token}` };
      await axios.delete(`${API}/teams/${teamId}/players/${registrationId}`, { headers });
      toast.success("Player removed from team!");
      fetchData();
    } catch (error) {
      toast.error("Failed to remove player");
    }
  };

  // Team publishing functions
  const handlePublishTeam = async (teamId) => {
    setPublishingTeam(teamId);
    try {
      const headers = { Authorization: `Bearer ${token}` };
      const response = await axios.post(`${API}/teams/${teamId}/publish`, {}, { headers });
      toast.success(response.data.message || "Team published successfully!");
      fetchData();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Failed to publish team");
    } finally {
      setPublishingTeam(null);
    }
  };

  const handleUnpublishTeam = async (teamId) => {
    setPublishingTeam(teamId);
    try {
      const headers = { Authorization: `Bearer ${token}` };
      await axios.post(`${API}/teams/${teamId}/unpublish`, {}, { headers });
      toast.success("Team unpublished!");
      fetchData();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Failed to unpublish team");
    } finally {
      setPublishingTeam(null);
    }
  };

  const handlePublishAllTeams = async () => {
    const pendingTeams = teams.filter(t => t.status !== 'published');
    if (pendingTeams.length === 0) {
      toast.info("No pending teams to publish");
      return;
    }
    
    if (!window.confirm(`Publish ${pendingTeams.length} team(s)? This will send notification emails to all team members.`)) {
      return;
    }
    
    setPublishingAll(true);
    try {
      const headers = { Authorization: `Bearer ${token}` };
      const response = await axios.post(`${API}/programs/${programId}/publish-all-teams`, {}, { headers });
      toast.success(response.data.message || "All teams published!");
      fetchData();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Failed to publish teams");
    } finally {
      setPublishingAll(false);
    }
  };

  // Friend requests functions
  const fetchFriendRequests = async () => {
    if (!program?.friend_requests_enabled) return;
    
    setFriendRequestsLoading(true);
    setFriendRequestsError("");
    try {
      const headers = { Authorization: `Bearer ${token}` };
      const res = await axios.get(`${API}/admin/programs/${programId}/friend-requests`, { headers });
      setFriendRequestsData(res.data);
    } catch (error) {
      console.error("Error fetching friend requests:", error);
      setFriendRequestsError("Unable to load friend requests. Try again.");
      toast.error("Failed to load friend requests");
    } finally {
      setFriendRequestsLoading(false);
    }
  };

  const handleMarkProcessed = async (registrationId, processed = true, notes = "") => {
    try {
      const headers = { Authorization: `Bearer ${token}` };
      await axios.put(`${API}/admin/friend-requests/${registrationId}/mark-processed`, {
        processed,
        notes
      }, { headers });
      toast.success(processed ? "Marked as processed" : "Marked as pending");
      fetchFriendRequests();
    } catch (error) {
      toast.error("Failed to update status");
    }
  };

  // Fetch friend requests when tab changes
  useEffect(() => {
    if (activeTab === "friendrequests" && program?.friend_requests_enabled) {
      fetchFriendRequests();
    }
  }, [activeTab, program]);

  if (loading) {
    return (
      <ProgramFrame embedded={embedded}>
        <div className="flex items-center justify-center h-64">
          <div className="animate-spin rounded-full h-12 w-12 border-2 border-slate-200 border-t-slate-900"></div>
        </div>
      </ProgramFrame>
    );
  }

  if (!program) {
    return (
      <ProgramFrame embedded={embedded} title="Program workspace">
        <div className="text-center py-16">
          <Trophy className="w-16 h-16 text-gray-300 mx-auto mb-4" />
          <h2 className="text-xl font-semibold text-slate-900 mb-2">Program Not Found</h2>
          <Button onClick={() => navigate(routeBase)} className="mt-4">
            Back to Programs
          </Button>
        </div>
      </ProgramFrame>
    );
  }

  // Calculate metrics
  const confirmedRegistrations = registrations.filter(r => r.status === 'confirmed');
  const pendingRegistrations = registrations.filter(r => r.status === 'pending' || r.status === 'incomplete' || (r.payment_status === 'pending' && r.status !== 'confirmed' && r.status !== 'tryout'));
  const waitlistedRegistrations = registrations.filter(r => r.status === 'waitlisted');
  const preRegisteredRegistrations = registrations.filter(r => r.status === 'pre_registered');
  const tryoutRegistrations = registrations.filter(r => r.status === 'tryout');
  const declinedRegistrations = registrations.filter(r => r.status === 'declined');
  const paidRegistrations = registrations.filter(r => r.payment_status === 'paid');
  const checkedInCount = registrations.filter(r => r.check_status === 'checked_in').length;
  const totalRevenue = paidRegistrations.reduce((sum, r) => sum + (r.amount || 0), 0);
  const enrollmentCount = program.current_participants || 0;
  const spotsRemaining = program.max_participants - enrollmentCount;
  const fillRate = program.max_participants > 0 
    ? Math.round(enrollmentCount / program.max_participants * 100)
    : 0;

  // Get unassigned registrations (not on any team)
  const unassignedRegistrations = registrations.filter(r => !r.team_id && r.status !== 'cancelled');

  // Get the organization's subdomain for constructing registration URLs
  const getOrgSubdomain = () => {
    const org = organizations.find(o => o.org_id === program?.org_id);
    return org?.subdomain;
  };

  // Generate the proper registration URL using org subdomain
  const getRegistrationUrl = (useSlug = true) => {
    const subdomain = getOrgSubdomain();
    if (subdomain) {
      // Use subdomain-based URL
      const baseUrl = `https://${subdomain}.sporthouse.ai`;
      if (useSlug && program.slug) {
        return `${baseUrl}/r/${program.slug}`;
      }
      return `${baseUrl}/program/${program.program_id}`;
    }
    // Fallback to path-based URL
    if (useSlug && program.slug) {
      return `${window.location.origin}/r/${program.slug}`;
    }
    return `${window.location.origin}/register/${program.program_id}`;
  };

  // Build menu items based on program type
  const getMenuItems = () => {
    const baseItems = [
      { id: "overview", label: "Overview", icon: BarChart3 },
      { id: "staff", label: "Staff", icon: Users },
    ];
    

    
    // For Camps - simplified menu
    if (program?.program_type === "camp") {
      return [
        ...baseItems,
        { id: "registrations", label: "Registrations", icon: ClipboardList, count: registrations.length },
        { id: "checkin", label: "Check-in", icon: UserCheck, count: checkedInCount },
        { id: "groups", label: "Team Builder", icon: UsersRound, count: teams.length },
        { id: "invoices", label: "Payments", icon: Receipt },
        { id: "emails", label: "Communications", icon: Mail },
      ];
    }
    
    // For Competitive teams
    if (program?.program_type === "competitive") {
      return [
        ...baseItems,
        { id: "registrations", label: "Registrations", icon: ClipboardList, count: registrations.length },
        { id: "checkin", label: "Check-in", icon: UserCheck, count: checkedInCount },
        { id: "teams", label: "Team Builder", icon: UsersRound, count: teams.length },
        { id: "invoices", label: "Payments", icon: Receipt },
        { id: "emails", label: "Communications", icon: Mail },
      ];
    }
    
    // For Recreational
    if (program?.program_type === "recreational") {
      return [
        ...baseItems,
        { id: "registrations", label: "Registrations", icon: ClipboardList, count: registrations.length },
        { id: "checkin", label: "Check-in", icon: UserCheck, count: checkedInCount },
        { id: "teams", label: "Team Builder", icon: UsersRound, count: teams.length },
        ...(program?.friend_requests_enabled ? [{ id: "friendrequests", label: "Friend Requests", icon: Heart }] : []),
        { id: "gamecards", label: "Game Cards", icon: QrCode },
        { id: "invoices", label: "Payments", icon: Receipt },
        { id: "emails", label: "Communications", icon: Mail },
      ];
    }
    
    // Default fallback - all features
    return [
      ...baseItems,
      { id: "registrations", label: "Registrations", icon: ClipboardList, count: registrations.length },
      ...(program?.friend_requests_enabled ? [{ id: "friendrequests", label: "Friend Requests", icon: Heart }] : []),
      ...(program?.tryouts_enabled ? [{ id: "tryouts", label: "Tryouts", icon: ClipboardCheck, count: tryoutStats?.total || 0 }] : []),
      { id: "checkin", label: "Check-in", icon: UserCheck, count: checkedInCount },
      { id: "teams", label: "Team Builder", icon: UsersRound, count: teams.length },
      { id: "invoices", label: "Payments", icon: Receipt },
      { id: "emails", label: "Communications", icon: Mail },
    ];
  };

  const menuItems = getMenuItems();

  const primarySectionIds = ["overview", "registrations", "teams", "groups", "invoices", "emails", "checkin", "staff"];
  const primarySections = primarySectionIds.map(id => menuItems.find(item => item.id === id)).filter(Boolean);
  const sections = [...primarySections, ...menuItems.filter(item => !primarySectionIds.includes(item.id))];
  const activeMenuItem = menuItems.find((item) => item.id === activeTab) || menuItems[0];

  const renderTabContent = () => {
    switch (activeTab) {
      case "overview": {
        const pendingRevenue = extras?.pending_revenue || 0;
        const expectedRevenue = extras?.expected_revenue || 0;
        const planBreakdown = extras?.payment_plan_breakdown || {};
        const staffSummary = extras?.staff_summary || {};
        const regTrend = extras?.registration_trend || [];
        const upcomingEvents = extras?.upcoming_events || [];
        const fillColor = fillRate >= 90 ? 'bg-red-500' : fillRate >= 70 ? 'bg-amber-500' : fillRate >= 40 ? 'bg-blue-500' : 'bg-emerald-500';
        const daysUntilClose = program.registration_close_date ? Math.ceil((new Date(program.registration_close_date) - new Date()) / (1000 * 60 * 60 * 24)) : null;
        const actionItems = [
          daysUntilClose !== null && daysUntilClose > 0 && daysUntilClose <= 7 && {
            id: "registration-closing",
            label: `Registration closes in ${daysUntilClose} day${daysUntilClose !== 1 ? 's' : ''}`,
            detail: `Review capacity and registration settings before ${new Date(program.registration_close_date).toLocaleDateString()}.`,
            editProgram: true,
            tone: "amber",
          },
          pendingRegistrations.length > 0 && {
            id: "pending-registrations",
            label: `${pendingRegistrations.length} registration${pendingRegistrations.length !== 1 ? 's' : ''} need review`,
            detail: "Resolve incomplete or pending registrations.",
            tab: "registrations",
            tone: "teal",
          },
          waitlistedRegistrations.length > 0 && {
            id: "waitlist",
            label: `${waitlistedRegistrations.length} participant${waitlistedRegistrations.length !== 1 ? 's' : ''} on the waitlist`,
            detail: "Review available capacity and promote participants when ready.",
            tab: "registrations",
            tone: "teal",
          },
          (planBreakdown.overdue || 0) > 0 && {
            id: "overdue-payments",
            label: `${planBreakdown.overdue} overdue payment plan${planBreakdown.overdue !== 1 ? 's' : ''}`,
            detail: `$${(planBreakdown.overdue_amount || 0).toLocaleString()} is past due.`,
            tab: "invoices",
            tone: "red",
          },
          teams.length > 0 && unassignedRegistrations.length > 0 && {
            id: "unassigned-players",
            label: `${unassignedRegistrations.length} player${unassignedRegistrations.length !== 1 ? 's' : ''} not assigned to ${getTeamLabel().toLowerCase()}`,
            detail: "Complete assignments before rosters are published.",
            tab: program.groups_enabled ? "groups" : "teams",
            tone: "teal",
          },
          registrations.length > 0 && (staffSummary.total_coaches || 0) === 0 && {
            id: "missing-staff",
            label: "No coaches assigned",
            detail: "Add program staff so families know who is leading the program.",
            tab: "staff",
            tone: "amber",
          },
        ].filter(Boolean);

        return (
          <div className="space-y-6">
            <section className="program-enrollment-summary" aria-label="Enrollment snapshot">
              <div><strong>{enrollmentCount}{program.max_participants > 0 ? ` / ${program.max_participants}` : ''}</strong><span>Registered{program.max_participants > 0 ? ' / capacity' : ''}</span></div>
              <div><strong>{teams.length}</strong><span>{getTeamLabel()}</span></div>
              <div><strong>{unassignedRegistrations.length}</strong><span>Unassigned records (excluding cancelled)</span></div>
            </section>
            <div className="program-approved-overview">
              <div className="program-overview-column">
              <section className="program-overview-panel program-details" aria-label="Program details">
                <div className="program-panel-heading"><h3 id="program-details-title">Program overview</h3></div>
                <dl>
                  <div><dt>Price</dt><dd>{program.price !== null && program.price !== undefined && program.price !== '' ? `$${program.price}` : 'Not set'}</dd></div>
                  {program.program_type && <div><dt>Program type</dt><dd className="capitalize">{program.program_type}</dd></div>}
                  {program.location && <div><dt>Location</dt><dd>{program.location}</dd></div>}
                  {program.start_date && <div><dt>Starts</dt><dd>{new Date(program.start_date + 'T00:00:00').toLocaleDateString()}</dd></div>}
                  {program.end_date && <div><dt>Ends</dt><dd>{new Date(program.end_date + 'T00:00:00').toLocaleDateString()}</dd></div>}
                  {program.registration_close_date && <div><dt>Registration closes</dt><dd>{new Date(program.registration_close_date).toLocaleDateString()}</dd></div>}
                </dl>
                <Button type="button" variant="ghost" className="m-3" onClick={() => navigate(`${routeBase}/${programId}/edit`)}>Edit program details</Button>
              </section>
            {/* #6: Upcoming Schedule for This Program */}
            {upcomingEvents.length > 0 && (
              <div className="bg-white border border-slate-200/60 rounded-2xl p-6">
                <div className="flex items-center justify-between mb-4">
                  <div className="flex items-center gap-2">
                    <Calendar className="w-5 h-5 text-slate-600" />
                    <h3 className="font-semibold text-slate-900">Upcoming Schedule</h3>
                  </div>
                  <Button variant="ghost" size="sm" onClick={() => setActiveTab('schedule')} className="rounded-xl text-slate-600">
                    View All <ChevronRight className="w-4 h-4 ml-1" />
                  </Button>
                </div>
                <div className="space-y-3">
                  {upcomingEvents.map((ev, idx) => (
                    <div key={idx} className="flex items-center gap-3 p-3 bg-slate-50 rounded-xl">
                      <div className={`w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0 ${
                        ev.type === 'game' ? 'bg-blue-100' : 'bg-violet-100'
                      }`}>
                        {ev.type === 'game' ? <Trophy className="w-5 h-5 text-blue-600" /> : <CalendarDays className="w-5 h-5 text-violet-600" />}
                      </div>
                      <div className="flex-1 min-w-0">
                        <p className="text-sm font-medium text-slate-800 truncate">{ev.title}</p>
                        <p className="text-xs text-slate-500">
                          {ev.start_time ? new Date(ev.start_time).toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' }) : 'TBD'}
                        </p>
                      </div>
                      <span className={`text-xs px-2 py-0.5 rounded-full flex-shrink-0 ${
                        ev.type === 'game' ? 'bg-blue-100 text-blue-700' : 'bg-violet-100 text-violet-700'
                      }`}>
                        {ev.type === 'game' ? 'Game' : ev.event_type || 'Event'}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            )}
                <section className="program-overview-panel" aria-labelledby="recent-registrations-title">
                  <div className="program-panel-heading">
                    <h3 id="recent-registrations-title">Recent registrations</h3>
                    <Button type="button" variant="ghost" size="sm" onClick={() => setActiveTab('registrations')}>View registrations</Button>
                  </div>
                  {registrations.length > 0 ? (
                    <div className="program-recent-table-wrap">
                      <table className="program-recent-table">
                        <thead><tr><th scope="col">Participant</th><th scope="col">Status</th><th scope="col">Payment</th><th scope="col">Registered</th></tr></thead>
                        <tbody>{[...registrations].sort((a, b) => (Date.parse(b.created_at) || 0) - (Date.parse(a.created_at) || 0)).slice(0, 5).map(reg => (
                          <tr key={reg.registration_id}>
                            <th scope="row">{reg.player?.first_name || 'Unknown'} {reg.player?.last_name || 'Player'}</th>
                            <td>{reg.status?.replace(/_/g, ' ') || 'Not available'}</td>
                            <td>{reg.payment_status?.replace(/_/g, ' ') || 'Not available'}</td>
                            <td>{reg.created_at && !Number.isNaN(Date.parse(reg.created_at)) ? new Date(reg.created_at).toLocaleDateString() : 'Not available'}</td>
                          </tr>
                        ))}</tbody>
                      </table>
                    </div>
                  ) : <p className="program-panel-empty">No registrations yet.</p>}
                </section>
              </div>
              <div className="program-overview-column">
                <section className="program-overview-panel program-builder-summary" aria-label="Team Builder summary">
                  <h3>Team Builder</h3>
                  <p>Keep enrollment and assignments in view.</p>
                  <dl>
                    <div><dt>Total {getTeamLabel()}</dt><dd>{teams.length}</dd></div>
                    <div><dt>Assigned records (all statuses)</dt><dd>{registrations.filter(r => r.team_id).length}</dd></div>
                    <div><dt>Unassigned records (excluding cancelled)</dt><dd>{unassignedRegistrations.length}</dd></div>
                  </dl>
                  <Button type="button" variant="outline" onClick={() => setActiveTab(program.program_type === 'camp' ? 'groups' : 'teams')}>Open Team Builder</Button>
                </section>
                <section className="program-overview-panel program-staff-summary" aria-label="Program staff">
                  <h3>Program staff</h3>
                  <dl><div><dt>Coaches assigned</dt><dd>{staffSummary.total_coaches || 0}</dd></div>
                    {staffSummary.head_coach_name && <div><dt>Head coach</dt><dd>{staffSummary.head_coach_name}</dd></div>}
                  </dl>
                  <Button type="button" variant="outline" onClick={() => setActiveTab('staff')}>View staff</Button>
                </section>
              </div>
            </div>
            <section className="program-operations" aria-label="Program operations">
              <h3>Program operations</h3>
            {actionItems.length > 0 && (
              <section className="program-overview-panel overflow-hidden" aria-labelledby="action-required-title">
                <div className="flex items-center justify-between border-b border-[#d8dfd9] px-5 py-4">
                  <div>
                    <h3 id="action-required-title" className="font-['Manrope'] text-lg font-extrabold text-[#101a19]">Action required</h3>
                  </div>
                  <span className="rounded-full bg-[#101a19] px-2.5 py-1 text-xs font-bold text-white">{actionItems.length}</span>
                </div>
                <div className="divide-y divide-[#e2e8e3]">
                  {actionItems.map((item) => (
                    <button key={item.id} onClick={() => item.editProgram ? navigate(`${routeBase}/${programId}/edit`) : setActiveTab(item.tab)} className="flex w-full items-center gap-3 px-5 py-4 text-left transition-colors hover:bg-[#f1f6f2]">
                      <span className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-xl ${item.tone === 'red' ? 'bg-red-100 text-red-700' : item.tone === 'amber' ? 'bg-[#fff1c7] text-[#8a5b00]' : 'bg-[#dff4ee] text-[#087c71]'}`}><AlertCircle className="h-4 w-4" /></span>
                      <span className="min-w-0 flex-1"><span className="block text-sm font-bold text-[#1b2a27]">{item.label}</span><span className="mt-0.5 block text-xs text-[#66736f]">{item.detail}</span></span>
                      <ChevronRight className="h-4 w-4 shrink-0 text-[#788781]" />
                    </button>
                  ))}
                </div>
              </section>
            )}

            <section aria-label="Program metrics" className="program-metrics">
              <button type="button" onClick={() => setActiveTab('registrations')}>
                <span>Total Registrations</span><strong>{registrations.length}</strong>
              </button>
              <button type="button" onClick={() => setActiveTab('registrations')}>
                <span>Capacity</span>
                <strong>{program.max_participants > 0 ? `${enrollmentCount} / ${program.max_participants}` : 'Not set'}</strong>
                {program.max_participants > 0 && <>
                  <span className="program-capacity-track"><span className={fillColor} style={{ width: `${Math.min(fillRate, 100)}%` }} /></span>
                  <small>{fillRate}% filled · {spotsRemaining > 0 ? `${spotsRemaining} spots remaining` : 'Full'}</small>
                </>}
              </button>
              <div><span>Revenue Collected</span><strong>${totalRevenue.toLocaleString()}</strong></div>
              <div><span>Pending Revenue</span><strong>${pendingRevenue.toLocaleString()}</strong></div>
              <div><span>Expected Total</span><strong>${expectedRevenue.toLocaleString()}</strong></div>
              <button type="button" onClick={() => setActiveTab('checkin')}>
                <span>Checked In Today</span><strong>{checkedInCount}</strong>
              </button>
            </section>
            </section>
            {/* #2: Registration Trend Mini-Chart + Status Breakdown */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              {/* Registration Trend */}
              <div className="bg-white border border-slate-200/60 rounded-2xl p-6">
                <h3 className="font-semibold text-slate-900 mb-4">Registration Trend (14 days)</h3>
                {regTrend.length > 0 ? (
                  <div className="flex items-end gap-1 h-32">
                    {regTrend.map((day, idx) => {
                      const maxCount = Math.max(...regTrend.map(d => d.count), 1);
                      const height = Math.max((day.count / maxCount) * 100, 4);
                      return (
                        <div key={idx} className="flex-1 flex flex-col items-center gap-1" title={`${day.label}: ${day.count}`}>
                          <span className="text-[10px] text-slate-400">{day.count > 0 ? day.count : ''}</span>
                          <div className="w-full bg-blue-500 rounded-t" style={{ height: `${height}%` }} />
                          {idx % 3 === 0 && <span className="text-[9px] text-slate-400 mt-1">{day.label?.slice(0,6)}</span>}
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <div className="h-32 flex items-center justify-center text-slate-400 text-sm">
                    <TrendingUp className="w-8 h-8 opacity-30 mr-2" /> No trend data yet
                  </div>
                )}
              </div>

              {/* Registration Status — #4: with waitlisted, pre-registered, declined */}
              <div className="bg-white border border-slate-200/60 rounded-2xl p-6">
                <h3 className="font-semibold text-slate-900 mb-4">Registration Status</h3>
                <div className="space-y-3">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2">
                      <CheckCircle className="w-4 h-4 text-green-500" />
                      <span className="text-sm text-slate-600">Confirmed</span>
                    </div>
                    <span className="font-semibold text-slate-900">{confirmedRegistrations.length}</span>
                  </div>
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2">
                      <Clock className="w-4 h-4 text-blue-500" />
                      <span className="text-sm text-slate-600">Pending</span>
                    </div>
                    <span className="font-semibold text-slate-900">{pendingRegistrations.length}</span>
                  </div>
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2">
                      <AlertCircle className="w-4 h-4 text-yellow-500" />
                      <span className="text-sm text-slate-600">Waitlisted</span>
                    </div>
                    <span className="font-semibold text-slate-900">{waitlistedRegistrations.length}</span>
                  </div>
                  {preRegisteredRegistrations.length > 0 && (
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-2">
                        <UserCheck className="w-4 h-4 text-violet-500" />
                        <span className="text-sm text-slate-600">Pre-Registered</span>
                      </div>
                      <span className="font-semibold text-slate-900">{preRegisteredRegistrations.length}</span>
                    </div>
                  )}
                  {declinedRegistrations.length > 0 && (
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-2">
                        <X className="w-4 h-4 text-red-500" />
                        <span className="text-sm text-slate-600">Declined</span>
                      </div>
                      <span className="font-semibold text-slate-900">{declinedRegistrations.length}</span>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Teams + Payment Status */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* Teams / Staff Card — #8 */}
              <div className="bg-white border border-slate-200/60 rounded-2xl p-6">
                <div className="flex items-center justify-between gap-3 mb-4">
                  <h3 className="font-semibold text-slate-900">{getTeamLabel()} & Staff</h3>
                  <Button type="button" variant="ghost" size="sm" onClick={() => setActiveTab('staff')}>Manage staff</Button>
                </div>
                <div className="space-y-3">
                  <div className="flex items-center justify-between">
                    <span className="text-sm text-slate-600">Total {getTeamLabel()}</span>
                    <span className="font-semibold text-slate-900">{teams.length}</span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-sm text-slate-600">Assigned Players</span>
                    <span className="font-semibold text-slate-900">{registrations.filter(r => r.team_id).length}</span>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-sm text-slate-600">Unassigned</span>
                    <span className="font-semibold text-slate-900">{unassignedRegistrations.length}</span>
                  </div>
                  <div className="pt-2 border-t border-slate-100">
                    <div className="flex items-center justify-between">
                      <span className="text-sm text-slate-600">Coaches Assigned</span>
                      <span className="font-semibold text-slate-900">{staffSummary.total_coaches || 0}</span>
                    </div>
                    {staffSummary.head_coach_name && (
                      <p className="text-xs text-slate-500 mt-1">Head Coach: {staffSummary.head_coach_name}</p>
                    )}
                  </div>
                </div>
              </div>

              {/* #7: Payment Status with plan breakdown */}
              <div className="bg-white border border-slate-200/60 rounded-2xl p-6">
                <h3 className="font-semibold text-slate-900 mb-4">Payment Status</h3>
                <div className="space-y-3">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2">
                      <CheckCircle className="w-4 h-4 text-green-500" />
                      <span className="text-sm text-slate-600">Paid</span>
                    </div>
                    <span className="font-semibold text-green-700">{paidRegistrations.length}</span>
                  </div>
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2">
                      <Clock className="w-4 h-4 text-amber-500" />
                      <span className="text-sm text-slate-600">Unpaid</span>
                    </div>
                    <div className="text-right">
                      <span className="font-semibold text-amber-700">{registrations.filter(r => r.payment_status === 'pending').length}</span>

                    </div>
                  </div>
                  {(planBreakdown.current || 0) > 0 && (
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-2">
                        <CreditCard className="w-4 h-4 text-blue-500" />
                        <span className="text-sm text-slate-600">Plan — Current</span>
                      </div>
                      <div className="text-right">
                        <span className="font-semibold text-blue-700">{planBreakdown.current}</span>
                        <p className="text-xs text-slate-400">${(planBreakdown.current_amount || 0).toLocaleString()} remaining</p>
                      </div>
                    </div>
                  )}
                  {(planBreakdown.overdue || 0) > 0 && (
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-2">
                        <AlertTriangle className="w-4 h-4 text-red-500" />
                        <span className="text-sm text-slate-600 font-medium">Plan — Overdue</span>
                      </div>
                      <div className="text-right">
                        <span className="font-semibold text-red-700">{planBreakdown.overdue}</span>
                        <p className="text-xs text-red-400">${(planBreakdown.overdue_amount || 0).toLocaleString()} past due</p>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>

          </div>
        );
      }

      case "staff":
        return (
          <ProgramStaffTab
            programId={programId}
            token={token}
            API={API}
          />
        );

      case "registrations":
        return (
          <ProgramRegistrationsTab
            program={program}
            programId={programId}
            registrations={registrations}
            teams={teams}
            token={token}
            API={API}
            onRefresh={fetchData}
          />
        );

      case "friendrequests":
        return (
          <ProgramFriendRequestsTab
            friendRequestsData={friendRequestsData}
            friendRequestsLoading={friendRequestsLoading}
            friendRequestsError={friendRequestsError}
            onRetry={fetchFriendRequests}
            onMarkProcessed={handleMarkProcessed}
          />
        );

      case "checkin":
        return (
          <ProgramCheckInTab
            registrations={registrations}
            programId={programId}
            token={token}
            API={API}
            onRefresh={fetchData}
          />
        );

      case "teams":
        return (
          <TeamBuilder
            teams={teams}
            registrations={registrations}
            programId={programId}
            token={token}
            API={API}
            onRefresh={fetchData}
            onCreateTeam={() => {
              setEditingTeam(null);
              setTeamForm({ name: "", color: "#000000", max_players: "" });
              setTeamDialogOpen(true);
            }}
            onEditTeam={openEditTeam}
            onDeleteTeam={handleDeleteTeam}
            onPublishTeam={handlePublishTeam}
            onUnpublishTeam={handleUnpublishTeam}
            onPublishAllTeams={handlePublishAllTeams}
            onAssignPlayers={handleAssignPlayers}
            onRemoveFromTeam={handleRemoveFromTeam}
            publishingTeam={publishingTeam}
            publishingAll={publishingAll}
            // Assign dialog state
            assignDialogOpen={assignDialogOpen}
            setAssignDialogOpen={setAssignDialogOpen}
            selectedTeam={selectedTeam}
            setSelectedTeam={setSelectedTeam}
            selectedPlayers={selectedPlayers}
            setSelectedPlayers={setSelectedPlayers}
            isGroupMode={program?.program_type === "camp" || (program?.program_type === "recreational" && program?.groups_enabled)}
            // Squadline props
            squadlineStatus={squadlineStatus}
            squadlineLoading={squadlineLoading}
            onConnectSquadline={handleConnectSquadline}
            onSyncToSquadline={fetchSquadlineStatus}
            onToggleSquadline={handleSquadlineToggle}
            enablingSquadline={enablingSquadline}
          />
        );

      case "groups":
        return (
          <TeamBuilder
            teams={teams}
            registrations={registrations}
            programId={programId}
            token={token}
            API={API}
            onRefresh={fetchData}
            onCreateTeam={() => {
              setEditingTeam(null);
              setTeamForm({ name: "", color: "#000000", max_players: "" });
              setTeamDialogOpen(true);
            }}
            onEditTeam={openEditTeam}
            onDeleteTeam={handleDeleteTeam}
            onPublishTeam={handlePublishTeam}
            onUnpublishTeam={handleUnpublishTeam}
            onPublishAllTeams={handlePublishAllTeams}
            onAssignPlayers={handleAssignPlayers}
            onRemoveFromTeam={handleRemoveFromTeam}
            publishingTeam={publishingTeam}
            publishingAll={publishingAll}
            // Assign dialog state
            assignDialogOpen={assignDialogOpen}
            setAssignDialogOpen={setAssignDialogOpen}
            selectedTeam={selectedTeam}
            setSelectedTeam={setSelectedTeam}
            selectedPlayers={selectedPlayers}
            setSelectedPlayers={setSelectedPlayers}
            isGroupMode={true}
            // Squadline props
            squadlineStatus={squadlineStatus}
            squadlineLoading={squadlineLoading}
            onConnectSquadline={handleConnectSquadline}
            onSyncToSquadline={fetchSquadlineStatus}
            onToggleSquadline={handleSquadlineToggle}
            enablingSquadline={enablingSquadline}
          />
        );
      case "invoices":
        return (
          <ProgramInvoicesTab
            program={program}
            token={token}
          />
        );

      case "emails":
        return (
          <ProgramEmailsTab
            program={program}
            onOpenWizard={() => navigate(`${routeBase}/${programId}/edit`)}
            onRefresh={fetchData}
          />
        );

      case "tryouts":
        return (
          <TryoutsManagement 
            program={program} 
            onUpdate={fetchData}
          />
        );

      case "bracket":
        return (
          <FeatureGate feature={Features.TOURNAMENT_MANAGEMENT}>
            <TournamentBracketBuilder 
              program={program} 
              onUpdate={fetchData}
            />
          </FeatureGate>
        );

      case "tournament":
        return (
          <FeatureGate feature={Features.TOURNAMENT_MANAGEMENT}>
            <div className="space-y-6">
              {tournamentLoading ? (
                <div className="flex justify-center py-12">
                  <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600"></div>
                </div>
              ) : linkedTournament ? (
                <>
                  {/* Tournament Header */}
                  <div className="bg-gradient-to-br from-purple-50 to-indigo-50 rounded-2xl border border-purple-200 p-6">
                    <div className="flex items-start justify-between">
                      <div>
                        <div className="flex items-center gap-3 mb-2">
                          <Trophy className="h-6 w-6 text-purple-600" />
                          <h3 className="text-xl font-bold text-slate-900">{linkedTournament.name}</h3>
                          <span className={`px-2 py-0.5 text-xs font-medium rounded-full ${
                            linkedTournament.status === "in_progress" ? "bg-green-100 text-green-700" :
                            linkedTournament.status === "completed" ? "bg-blue-100 text-blue-700" :
                            "bg-amber-100 text-amber-700"
                          }`}>
                            {linkedTournament.status?.replace("_", " ")}
                          </span>
                        </div>
                        <div className="flex items-center gap-4 text-sm text-slate-600">
                          <span className="capitalize">{linkedTournament.format?.replace("_", " ")}</span>
                          <span>•</span>
                          <span>{linkedTournament.teams?.length || 0} / {linkedTournament.max_teams} teams</span>
                          <span>•</span>
                          <span>{linkedTournament.games?.filter(g => g.status === "completed").length || 0} games completed</span>
                        </div>
                      </div>
                      <Button
                        onClick={() => navigate(`/admin/tournaments/${linkedTournament.tournament_id}`)}
                        className="bg-purple-600 hover:bg-purple-700"
                      >
                        <ExternalLink className="h-4 w-4 mr-2" />
                        Manage Tournament
                      </Button>
                    </div>
                  </div>

                  {/* Quick Stats */}
                  <div className="grid grid-cols-4 gap-4">
                    <div className="bg-white rounded-xl border p-4">
                      <div className="flex items-center gap-3">
                        <div className="p-2 bg-indigo-100 rounded-lg">
                          <Users className="h-5 w-5 text-indigo-600" />
                        </div>
                        <div>
                          <p className="text-2xl font-bold text-slate-900">{linkedTournament.teams?.length || 0}</p>
                          <p className="text-xs text-slate-500">{getTeamLabel()}</p>
                        </div>
                      </div>
                    </div>
                    <div className="bg-white rounded-xl border p-4">
                      <div className="flex items-center gap-3">
                        <div className="p-2 bg-green-100 rounded-lg">
                          <CheckCircle className="h-5 w-5 text-green-600" />
                        </div>
                        <div>
                          <p className="text-2xl font-bold text-slate-900">
                            {linkedTournament.games?.filter(g => g.status === "completed").length || 0}
                          </p>
                          <p className="text-xs text-slate-500">Games Completed</p>
                        </div>
                      </div>
                    </div>
                    <div className="bg-white rounded-xl border p-4">
                      <div className="flex items-center gap-3">
                        <div className="p-2 bg-amber-100 rounded-lg">
                          <Clock className="h-5 w-5 text-amber-600" />
                        </div>
                        <div>
                          <p className="text-2xl font-bold text-slate-900">
                            {linkedTournament.games?.filter(g => g.status === "scheduled" && !g.is_bye).length || 0}
                          </p>
                          <p className="text-xs text-slate-500">Games Remaining</p>
                        </div>
                      </div>
                    </div>
                    <div className="bg-white rounded-xl border p-4">
                      <div className="flex items-center gap-3">
                        <div className="p-2 bg-purple-100 rounded-lg">
                          <Target className="h-5 w-5 text-purple-600" />
                        </div>
                        <div>
                          <p className="text-2xl font-bold text-slate-900">
                            {linkedTournament.bracket?.num_rounds || "—"}
                          </p>
                          <p className="text-xs text-slate-500">Rounds</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Embedded Bracket View */}
                  <TournamentBracketView
                    tournament={linkedTournament}
                    teams={linkedTournament.teams || []}
                    games={linkedTournament.games || []}
                    onScoreUpdate={(game) => navigate(`/admin/tournaments/${linkedTournament.tournament_id}`)}
                    onRefresh={fetchData}
                    isAdmin={true}
                  />
                </>
              ) : (
                <div className="bg-white rounded-xl border p-12 text-center">
                  <Trophy className="h-12 w-12 text-slate-300 mx-auto mb-4" />
                  <h3 className="text-lg font-semibold text-slate-900 mb-2">No Tournament Linked</h3>
                  <p className="text-slate-600 mb-6">
                    This program does not have a tournament linked yet.
                  </p>
                  <Button
                    onClick={() => navigate("/admin/tournaments")}
                    className="bg-purple-600 hover:bg-purple-700"
                  >
                    <Plus className="h-4 w-4 mr-2" />
                    Create Tournament
                  </Button>
                </div>
              )}
            </div>
          </FeatureGate>
        );

      case "schedule":
        // Use TournamentScheduleManager for tournaments, LeagueScheduleBuilder for leagues
        if (program?.program_type === "tournament") {
          return (
            <TournamentScheduleManager 
              program={program} 
              onUpdate={fetchData}
            />
          );
        }
        return (
          <FeatureGate feature={Features.LEAGUE_MANAGEMENT}>
            <LeagueScheduleBuilder 
              program={program} 
              onUpdate={fetchData}
            />
          </FeatureGate>
        );

      case "standings":
        return (
          <FeatureGate feature={Features.LEAGUE_MANAGEMENT}>
            <LeagueStandings 
              program={program} 
              onUpdate={fetchData}
            />
          </FeatureGate>
        );

      case "gamecards":
        return (
          <GameCards 
            program={program} 
            onUpdate={fetchData}
          />
        );

      default:
        return null;
    }
  };

  return (
    <ProgramFrame embedded={embedded}>
      <div className="program-workspace space-y-5 pb-10" data-testid="program-dashboard">
        <button onClick={() => navigate(routeBase)} className="inline-flex items-center gap-1 text-sm font-semibold text-[#66736f] transition-colors hover:text-[#087c71]">
          <ChevronRight className="h-4 w-4 rotate-180" /> All programs
        </button>

        <header role="banner" aria-label="Program summary" className="program-workspace-header border-b border-[#d8dfd9] pb-5">
          <div>
            <div className="flex flex-col gap-5 xl:flex-row xl:items-start xl:justify-between">
              <div className="flex min-w-0 items-start gap-4">
                {program.logo_url ? (
                  <img loading="lazy" src={program.logo_url} alt="" className="h-12 w-12 shrink-0 rounded-xl border border-[#d8dfd9] bg-white object-contain p-1" />
                ) : (
                  <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-[#dff4ee]">
                    <Trophy className="h-7 w-7 text-[#087c71]" />
                  </div>
                )}
                <div className="min-w-0">
                  <div className="mb-2 flex flex-wrap items-center gap-2">
                    {program.sport && <span className="rounded-full bg-[#101a19] px-2.5 py-1 text-[11px] font-bold uppercase tracking-[0.12em] text-white">{program.sport}</span>}
                    <span className={`rounded-full px-2.5 py-1 text-[11px] font-bold uppercase tracking-[0.1em] ${
                      program.status === 'active' || program.status === 'published' ? 'bg-[#dff4ee] text-[#087c71]' :
                      program.status === 'draft' ? 'bg-[#fff1c7] text-[#8a5b00]' :
                      program.status === 'archived' ? 'bg-[#e8ece8] text-[#66736f]' :
                      program.status === 'completed' ? 'bg-[#e2ecff] text-[#315f9d]' :
                      'bg-[#e8ece8] text-[#66736f]'
                    }`}>
                      {(program.status || 'active').charAt(0).toUpperCase() + (program.status || 'active').slice(1)}
                    </span>
                  </div>
                  <h1 id="program-title" className="break-words font-['Manrope'] text-2xl font-extrabold tracking-[-0.03em] text-[#101a19] sm:text-3xl">{program.name}</h1>
                  <div className="mt-3 flex flex-wrap items-center gap-x-4 gap-y-2 text-sm text-[#66736f]">
                    {program.location && (
                      <div className="flex items-center gap-1">
                        <MapPin className="h-4 w-4 text-[#087c71]" />
                        <span>{program.location}</span>
                      </div>
                    )}
                    {program.start_date && (
                      <div className="flex items-center gap-1">
                        <Calendar className="h-4 w-4 text-[#087c71]" />
                        <span>{new Date(program.start_date + 'T00:00:00').toLocaleDateString()}</span>
                      </div>
                    )}
                    {(program.age_min || program.age_max) && <div className="flex items-center gap-1"><Users className="h-4 w-4 text-[#087c71]" /><span>Ages {program.age_min || 'Any'}–{program.age_max || 'Any'}</span></div>}
                  </div>
                </div>
              </div>
              <div className="flex flex-wrap items-center gap-2 sm:justify-end">
                <Button 
                  variant="outline"
                  onClick={() => {
                    const publicUrl = getRegistrationUrl(true);
                    navigator.clipboard.writeText(publicUrl);
                    toast.success("Registration link copied to clipboard!");
                  }}
                  className="rounded-full border-[#b8c8c1] bg-[#fbfcf8] text-[#28433e] hover:bg-white"
                  data-testid="copy-link-btn"
                >
                  <Copy className="w-4 h-4 mr-2" />
                  {program.slug ? "Copy Short Link" : "Copy Link"}
                </Button>
                <Button onClick={() => navigate(`${routeBase}/${programId}/edit`)} className="rounded-full bg-[#087c71] px-5 text-white shadow-sm hover:bg-[#06665e]">
                  <Edit className="w-4 h-4 mr-2" />
                  Edit Program
                </Button>
                {/* #10: Secondary actions in dropdown */}
                <DropdownMenu>
                  <DropdownMenuTrigger asChild>
                    <Button variant="outline" size="icon" aria-label="More program actions" className="rounded-full border-[#b8c8c1] bg-[#fbfcf8]">
                      <MoreVertical className="w-4 h-4" />
                    </Button>
                  </DropdownMenuTrigger>
                  <DropdownMenuContent align="end" className="w-52">
                    <DropdownMenuItem onClick={() => { window.open(getRegistrationUrl(true), '_blank'); }}>
                      <ExternalLink className="w-4 h-4 mr-2" /> View Public Page
                    </DropdownMenuItem>
                    <DropdownMenuItem onClick={() => setQrDialogOpen(true)}>
                      <QrCode className="w-4 h-4 mr-2" /> QR Code
                    </DropdownMenuItem>
                    <DropdownMenuSeparator />
                    <DropdownMenuItem onClick={() => setReEnrollOpen(true)}>
                      <UserPlus className="w-4 h-4 mr-2" /> Invite Returning Players
                    </DropdownMenuItem>
                    <DropdownMenuItem onClick={() => navigate(`/admin/messaging`)}>
                      <Send className="w-4 h-4 mr-2" /> Email All Registrants
                    </DropdownMenuItem>
                    <DropdownMenuItem onClick={() => {
                      const csv = registrations.map(r => `${r.first_name || ''},${r.last_name || ''},${r.email || ''},${r.phone || ''},${r.status || ''},${r.payment_status || ''}`).join('\n');
                      const blob = new Blob([`First Name,Last Name,Email,Phone,Status,Payment\n${csv}`], { type: 'text/csv' });
                      const url = URL.createObjectURL(blob);
                      const a = document.createElement('a'); a.href = url; a.download = `${program.name}-roster.csv`; a.click();
                      toast.success('Roster exported');
                    }}>
                      <Download className="w-4 h-4 mr-2" /> Export Roster
                    </DropdownMenuItem>
                  </DropdownMenuContent>
                </DropdownMenu>
              </div>
            </div>

          </div>
        </header>

        <div>
          <nav className="program-section-nav" aria-label="Program sections">
            {sections.map(item => (
              <button key={item.id} data-section={item.id} type="button" onClick={() => setActiveTab(item.id)} aria-current={activeTab === item.id ? 'page' : undefined}>
                {item.label}
                {item.count > 0 && <span className="program-section-count">{item.count}</span>}
              </button>
            ))}
          </nav>
          <main ref={builderRegionRef} className={`min-w-0${builderFocus ? ' program-builder-focus' : ''}`} aria-label={activeMenuItem?.label}>
            {isBuilderTab && <div className="program-builder-focus-bar">
              {builderFocus && <div className="program-builder-focus-identity"><strong>{program.name}</strong><span>Team Builder</span></div>}
              <Button ref={builderFocus ? exitBuilderRef : expandBuilderRef} type="button" variant="outline" onClick={() => setBuilderFocus(current => !current)}>
                {builderFocus ? 'Exit full screen' : 'Expand Team Builder'}
              </Button>
            </div>}
            <h2 className="sr-only">{activeMenuItem?.label}</h2>
            {renderTabContent()}
          </main>
        </div>
      </div>

      {/* #9: QR Code Dialog */}
      <Dialog open={qrDialogOpen} onOpenChange={setQrDialogOpen}>
        <DialogContent className="sm:max-w-md">
          <DialogHeader>
            <DialogTitle>Registration QR Code</DialogTitle>
            <DialogDescription>Scan to open the registration page for {program?.name}</DialogDescription>
          </DialogHeader>
          <div className="flex flex-col items-center gap-4 py-4">
            <img
              src={`https://api.qrserver.com/v1/create-qr-code/?size=250x250&data=${encodeURIComponent(getRegistrationUrl(true))}`}
              alt="Registration QR Code"
              className="w-64 h-64 rounded-xl border border-slate-200"
            />
            <p className="text-xs text-slate-500 text-center break-all max-w-xs">{getRegistrationUrl(true)}</p>
          </div>
          <DialogFooter className="flex gap-2">
            <Button variant="outline" className="rounded-full" onClick={() => {
              navigator.clipboard.writeText(getRegistrationUrl(true));
              toast.success('Link copied');
            }}>
              <Copy className="w-4 h-4 mr-1.5" /> Copy Link
            </Button>
            <Button className="rounded-full" onClick={() => {
              const link = document.createElement('a');
              link.href = `https://api.qrserver.com/v1/create-qr-code/?size=500x500&format=png&data=${encodeURIComponent(getRegistrationUrl(true))}`;
              link.download = `${program?.name}-qr-code.png`;
              link.click();
              toast.success('QR code downloaded');
            }}>
              <Download className="w-4 h-4 mr-1.5" /> Download PNG
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Create/Edit Team/Group Dialog */}
      <Dialog open={teamDialogOpen} onOpenChange={setTeamDialogOpen}>
        <DialogContent className="max-w-md bg-white">
          <DialogHeader>
            <DialogTitle>
              {editingTeam 
                ? `Edit ${program?.groups_enabled ? "Group" : "Team"}` 
                : `Create ${program?.groups_enabled ? "Group" : "Team"}`}
            </DialogTitle>
            <DialogDescription>
              {editingTeam 
                ? `Update ${program?.groups_enabled ? "group" : "team"} details` 
                : `Create a new ${program?.groups_enabled ? "group" : "team"} for this program`}
            </DialogDescription>
          </DialogHeader>
          <div className="space-y-4 py-4">
            <div>
              <Label>{program?.groups_enabled ? "Group" : "Team"} Name *</Label>
              <Input
                className="mt-1 border-slate-300"
                placeholder={program?.groups_enabled ? "e.g., Morning Group A" : "e.g., Red Dragons"}
                value={teamForm.name}
                onChange={(e) => setTeamForm({ ...teamForm, name: e.target.value })}
              />
            </div>
            <div>
              <Label>{program?.groups_enabled ? "Group" : "Team"} Color</Label>
              <div className="flex items-center gap-2 mt-1">
                <input
                  type="color"
                  value={teamForm.color}
                  onChange={(e) => setTeamForm({ ...teamForm, color: e.target.value })}
                  className="w-10 h-10 rounded cursor-pointer border-0"
                />
                <Input
                  value={teamForm.color}
                  onChange={(e) => setTeamForm({ ...teamForm, color: e.target.value })}
                  className="flex-1 border-slate-300"
                />
              </div>
            </div>
            
            {/* Staff assignment note */}
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
              <p className="text-sm text-blue-800">
                <strong>Tip:</strong> To assign coaches and staff to this team, use the <span className="font-semibold">Manage Staff</span> button (graduation cap icon) on the team card after creating or updating the team.
              </p>
            </div>
            
            <div>
              <Label>Max {program?.groups_enabled ? "Campers" : "Players"}</Label>
              <Input
                type="number"
                className="mt-1 border-slate-300"
                placeholder="Leave empty for unlimited"
                value={teamForm.max_players}
                onChange={(e) => setTeamForm({ ...teamForm, max_players: e.target.value })}
              />
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setTeamDialogOpen(false)}>Cancel</Button>
            <Button onClick={handleCreateTeam} className="bg-slate-900 text-white hover:bg-slate-800">
              {editingTeam 
                ? `Update ${program?.groups_enabled ? "Group" : "Team"}` 
                : `Create ${program?.groups_enabled ? "Group" : "Team"}`}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Assign Players Dialog */}
      <Dialog open={assignDialogOpen} onOpenChange={setAssignDialogOpen}>
        <DialogContent className="max-w-lg bg-white">
          <DialogHeader>
            <DialogTitle>Assign Players to Team</DialogTitle>
            <DialogDescription>
              Select players to assign to {teams.find(t => t.team_id === selectedTeam)?.name || 'a team'}
            </DialogDescription>
          </DialogHeader>
          <div className="py-4">
            {!selectedTeam && teams.length > 0 && (
              <div className="mb-4">
                <Label>Select Team</Label>
                <div className="flex flex-wrap gap-2 mt-2">
                  {teams.map((team) => (
                    <button
                      key={team.team_id}
                      onClick={() => setSelectedTeam(team.team_id)}
                      className={`px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
                        selectedTeam === team.team_id
                          ? 'bg-slate-900 text-white'
                          : 'bg-slate-100 text-slate-700 hover:bg-gray-200'
                      }`}
                    >
                      {team.name}
                    </button>
                  ))}
                </div>
              </div>
            )}
            
            <Label>Select Players</Label>
            <div className="mt-2 max-h-64 overflow-y-auto space-y-2">
              {unassignedRegistrations.map((reg) => (
                <label
                  key={reg.registration_id}
                  className={`flex items-center gap-3 p-3 rounded-lg cursor-pointer transition-colors ${
                    selectedPlayers.includes(reg.registration_id) ? 'bg-slate-900 text-white' : 'bg-slate-50 hover:bg-slate-100'
                  }`}
                >
                  <input
                    type="checkbox"
                    checked={selectedPlayers.includes(reg.registration_id)}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setSelectedPlayers([...selectedPlayers, reg.registration_id]);
                      } else {
                        setSelectedPlayers(selectedPlayers.filter(id => id !== reg.registration_id));
                      }
                    }}
                    className="w-4 h-4"
                  />
                  <span className="font-medium">
                    {reg.player?.first_name} {reg.player?.last_name}
                  </span>
                </label>
              ))}
              {unassignedRegistrations.length === 0 && (
                <p className="text-slate-500 text-center py-4">All players are already assigned to teams</p>
              )}
            </div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setAssignDialogOpen(false)}>Cancel</Button>
            <Button 
              onClick={handleAssignPlayers} 
              className="bg-slate-900 text-white hover:bg-slate-800"
              disabled={!selectedTeam || selectedPlayers.length === 0}
            >
              Assign {selectedPlayers.length} Player{selectedPlayers.length !== 1 ? 's' : ''}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
      {/* Re-Enrollment Dialog */}
      {program && (
        <ReEnrollmentDialog
          open={reEnrollOpen}
          onOpenChange={setReEnrollOpen}
          program={program}
          programs={allPrograms}
          token={token}
        />
      )}
    </ProgramFrame>
  );
};

export default AdminProgramDashboard;
